import { render, staticRenderFns } from "./sender-address.vue?vue&type=template&id=52b7dfeb&"
import script from "./sender-address.vue?vue&type=script&lang=js&"
export * from "./sender-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports